import m from 'mithril'
import moment from 'moment'
import BaseModel from './_base'

let _datas = []

const constraints = {
    title: {
        presence: {
            allowEmpty: false,
            message: "^請輸入資訊主題"
        }
    },
    content: {
        presence: {
            allowEmpty: false,
            message: "^請輸入資訊內容"
        }
    },
}

class UserFavorite extends BaseModel {
    constructor(args) {
        super(constraints)
        args = (args) ? args : {};
        this.id = args.id || 0;
        this.user_id = args.user_id || null;
        this.title = args.title || '';
        this.content = args.content || '';
        
    }

    static get datas() {
        return _datas;
    }

    static fetch() {
        UserFavorite.loading = true
        return m.request({
            method: 'POST',
            url: `/api/setting/favorite/fetch`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },

        }).then((response) => {
            _datas = response
            UserFavorite.loading = false
            return response
        })
    }

    static add(model_id) {
        UserFavorite.loading = true
        return m.request({
            method: 'POST',
            url: `/api/setting/favorite/add`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data: {
                model_id: model_id
            }
        }).then((response) => {
            UserFavorite.loading = false
        })
    }
    static remove (model_id){
        UserFavorite.loading = true
        return m.request({
            method: 'POST',
            url: `/api/setting/favorite/remove`,
            headers: {
                "Authorization": "Bearer " + window.JWTAuth,
            },
            data: {
                model_id: model_id
            }
        }).then((response) => {
            UserFavorite.loading = false
        })
    }
    

}

export default UserFavorite